import { atom } from 'jotai';

type DeleteTranscriptData = {
  sessionId: string;
  onTranscriptDeleted?: () => void;
};

export const deleteTranscriptDataAtom = atom<DeleteTranscriptData | undefined>(undefined);
